import React, { useEffect, useRef } from 'react';
import { Box, Heading } from '@chakra-ui/react';

const BVReviews = ({ productName, productSlug }) => {
  const reviewBoxRef = useRef(null);

  const transformedName = productSlug
    .toLowerCase()
    .trim()
    .replace(`product-`, ``)
    .replace(/[%]|w\/w/g, ``)
    .replace(/ +/g, `-`);

  const transformReviewStyle = () => {
    const sDom = document.querySelector(`[data-bv-show="reviews"]`)?.shadowRoot;

    const observer = new MutationObserver((mutationList) => {
      mutationList.forEach((mutation) => {
        if (mutation.type === `childList` && mutation.addedNodes.length === 0) {
          if (mutation.target.id !== `bv_review_maincontainer`) {
            const reviews = sDom
              ?.querySelector(`#bv_review_maincontainer #reviews_container`)
              ?.querySelectorAll(`[data-bv-v="contentItem"]`);
            reviews?.forEach((review) => {
              // eslint-disable-next-line no-param-reassign
              review.style.flexDirection = `column`;
              const reviewerInfo = review?.querySelector(
                `[data-bv-v="inlineProfile"]`
              );
              reviewerInfo.style.width = `100%`;
              reviewerInfo.style.maxWidth = `100%`;
              // eslint-disable-next-line prefer-destructuring
              const reviewBox = review.querySelectorAll(`& > div`)[1];
              reviewBox.style.flexDirection = `column`;
              const [reviewBoxReview, reviewBoxRating] =
                reviewBox.querySelectorAll(`& > div`);
              reviewBoxReview.style.width = `100%`;
              if (reviewBoxRating) {
                reviewBoxRating.style.width = `100%`;
                const reviewBoxRatingContainer = reviewBoxRating.querySelector(
                  `div[role="presentation"]`
                );
                const reviewBoxRatings =
                  reviewBoxRatingContainer?.querySelectorAll(
                    `& > div[role="presentation"]`
                  );
                reviewBoxRatings?.forEach((rating) => {
                  // eslint-disable-next-line prefer-destructuring
                  const ratingValue = rating?.querySelectorAll(
                    `& > div[role="presentation"]`
                  )[1];
                  ratingValue.querySelector(
                    `div[aria-hidden="true"]`
                  ).style.fontSize = `14px`;
                });
              }
            });
          }
        }
      });
    });

    observer.observe(sDom, {
      attributes: true,
      childList: true,
      subtree: true
    });
  };

  useEffect(() => {
    const script = document.createElement(`script`);
    script.type = `application/ld+json`;
    script.text = JSON.stringify({
      '@context': `https://schema.org`,
      '@type': `Product`,
      '@id': `${window.location.href}`,
      name: productName
    });
    document.head.appendChild(script);

    const reviews = document.querySelector(`[data-bv-show="reviews"]`);

    const observer = new MutationObserver((mutationList) => {
      if (mutationList.length > 0) transformReviewStyle();
    });

    observer.observe(reviews, {
      attributes: true,
      childList: true,
      subtree: true
    });

    return () => {
      observer.disconnect();
      document.head.removeChild(script);
    };
  }, [productName, transformedName]);

  return (
    <Box>
      <Heading
        color="purple.600"
        as="h1"
        mb="5"
        size="2xl"
        textTransform="uppercase">
        Look what our users think
      </Heading>
      <Box itemScope itemType="http://schema.org/Product">
        <meta itemProp="name" content={`product-${transformedName}`} />
        <Box
          data-bv-show="reviews"
          data-bv-product-id={`product-${transformedName}`}
          ref={reviewBoxRef}
          sx={{
            '#bv_review_maincontainer': {
              border: `1px solid red`
            }
          }}
        />
      </Box>
    </Box>
  );
};

export default BVReviews;
